import { COUNTRY_MODEL_MAP, DEFAULT_COUNTRY_KEY, MODEL_SHARD_CONFIG } from "src/constants/countryConfig";
import axiosInstance from "./axiosInstance";
import { shouldUseOnnxModel } from "src/utils/deviceDetector";

export const fetchForLiveness = async () => {
    const urls = [
        "/mediapipe/face_detection/blaze_face_short_range.tflite",
        "/mediapipe/tasks-vision/wasm/vision_wasm_internal.js",
        "/mediapipe/tasks-vision/wasm/vision_wasm_internal.wasm",
        "/model/face_landmarker.task"
    ];

    const requests = urls.map((url, index) =>
        axiosInstance.get(url, {
            headers: {
                'Cache-Control': 'public, max-age=31536000'
            }
        }).then(res => {
            //logger.log(`CDN ${index + 1} Response:`, res);
        }).catch(err => {
            //logger.error(`CDN ${index + 1} Error:`, err);
        })
    );

    await Promise.all(requests);
};

export const fetchForIdVerification = async (selectedCountry) => {
    const useOnnx = shouldUseOnnxModel();

    if (useOnnx) {
        const onnxModelUrl = "/card_no_card_v8n_19_11_25.onnx";

        try {
            await axiosInstance.get(onnxModelUrl, {
                headers: {
                    'Cache-Control': 'public, max-age=31536000'
                }
            });
            //logger.log('ONNX model pre-fetched successfully');
        } catch (err) {
            //logger.error('ONNX model pre-fetch error:', err);
        }

        return;
    }

    const modelName = "yolov8n";
    const urls = getUrlsByCountry(selectedCountry, modelName);

    const requests = urls.map((url, index) =>
        axiosInstance.get(url, {
            headers: {
                'Cache-Control': 'public, max-age=31536000'
            }
        }).then(res => {
            //logger.log(`CDN ${index + 1} Response:`, res);
        }).catch(err => {
            //logger.error(`CDN ${index + 1} Error:`, err);
        })
    );

    await Promise.all(requests);
};

const getUrlsByCountry = (selectedCountry, modelName) => {
    const countryKey = COUNTRY_MODEL_MAP[selectedCountry] || DEFAULT_COUNTRY_KEY;
    const totalShards = MODEL_SHARD_CONFIG[countryKey] || MODEL_SHARD_CONFIG[DEFAULT_COUNTRY_KEY];
    return generateShardUrls(modelName, countryKey, totalShards);
};

const generateShardUrls = (modelName, countryKey, totalShards) => {
    const basePath = `${modelName}_web_model_${countryKey}`;
    const urls = [`${basePath}/model.json`];
    for (let i = 1; i <= totalShards; i++) {
        urls.push(`${basePath}/group1-shard${i}of${totalShards}.bin`);
    }
    return urls;
};